module.exports = __webpack_public_path__ + "img/camera.5c329b25.png";